import LoginPage from 'common/components/account/login-page';
import ForgotPassword from 'common/components/account/forgot-password-page';
import ResetPassword from 'common/components/account/reset-password-page';
import LoginLand from '../components/login-land';

import Overview from '../components/overview-page'
import Console from '../components/console-page'
import ChartPage from '../components/chart-page'

export const routes = [
    { name: 'home', path: '/', component: Overview, display: 'Overview', icon: 'home', meta: { auth: true } },
    { name: 'overview', path: '/overview', component: Overview, display: 'Overview', icon: 'home', meta: { auth: true } },
    { name: 'console', path: '/console', component: Console, display: 'Console', icon: 'home', meta: { auth: true } },
    { name: 'chart', path: '/chart', component: ChartPage, display: 'Chart Page', icon: 'chart', meta: { auth: true } },

    { name: 'login', path: '/login', alias: '/account/login', component: LoginPage, props: { productName: 'cmp', themeColour: '#00b0ed', redirectPath: '/login-land' }, meta: { title: () => 'Comms Manager' } },
    { path: '/forgot-password', component: ForgotPassword, props: { productName: 'cmp', themeColour: '#00b0ed' }, meta: { title: () => 'Comms Manager' } },
    { path: '/reset-password', alias: '/account/password-reset', component: ResetPassword, props: { productName: 'cmp', themeColour: '#00b0ed' }, meta: { title: () => 'Comms Manager' } },
    { name: 'login-land', path: '/login-land', component: LoginLand, meta: { title: () => 'Comms Manager' } },
]
